<template>
  <div class="bg-white profileInfoDialog details-container">
    <div class="p-d-flex p-jc-end">
      <base-icon
        name="closeSmall"
        class="fill-gray"
        @click="emit('closedVisibilityNotice')"
      />
    </div>
    <div class="p-d-flex">
      <p>
       {{ t('ProfilePage.ProfilePicture.YouCanCheckTheVisibilityOfYourProfilePictureAt') }}
        <RouterLink to="/node/6128"
                     @click="emit('clickedRouterLink', 'closedVisibilityNotice')"
        >
        {{ t('ProfilePage.ProfilePicture.PublicProfile') }}
        </RouterLink>
        {{ t('ProfilePage.ProfilePicture.Set') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { RouterLink } from 'vue-router';

const {t} = useI18n();
const emit = defineEmits<{
  closedVisibilityNotice: [],
  clickedRouterLink: [string]
}>();

</script>

<style lang="css" scoped>
.details-container {
  position: absolute;
  
  border-radius: 4px;
  padding: 0.75rem;
  z-index: 99;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 10px #00000029;
}

.link-padding {
  padding-left: .5rem;
  padding-right: .5rem;
}

svg:hover {
  cursor: pointer
}
</style>
